import { create } from 'zustand';
import { SpecialPackageTableDataType } from 'typings/specialPackages.type';
import {
  getChartDataAction,
  getListDataAction,
  setHideDetailsCardAction,
  setIsSampleBasketAction,
} from './action';

type SpecialPackagesType = {
  isHideDetailsCard: boolean;
  setHideDetailsCardAction: (detailCardStatus?: boolean) => void;
  listDataLoading: boolean;
  listData: SpecialPackageTableDataType;
  listDataError: boolean;
  startDate: string;
  endDate: string;
  getListDataAction: () => void;
  chartDataLoading: boolean;
  chartData: { basketReturn: number; indexReturn: number; date: string }[];
  defaultChartData: {
    basketReturn: number;
    indexReturn: number;
    date: string;
  }[];
  chartDataError: boolean;
  getChartDataAction: (startDate?: string, endDate?: string) => void;
  isSampleBasket: boolean;
  setIsSampleBasketAction: (isSampleBasket: boolean) => void;
  reset: () => void;
};

const initialState = {
  isHideDetailsCard: null,
  listDataLoading: false,
  listData: null,
  listDataError: false,
  chartDataLoading: false,
  chartData: null,
  chartDataError: false,
  startDate: null,
  endDate: null,
  isSampleBasket: false,
  defaultChartData: null,
};

const useSpecialPackagesStore = create<SpecialPackagesType>((set) => ({
  ...initialState,
  reset: (): void => set(initialState),
  setHideDetailsCardAction: (showDetailsCard?: boolean): void =>
    setHideDetailsCardAction(set, showDetailsCard),
  getChartDataAction: (startDate: string, endDate: string): Promise<void> =>
    getChartDataAction(set, startDate, endDate),
  getListDataAction: (): Promise<void> => getListDataAction(set),
  setIsSampleBasketAction: (isSampleBasket: boolean): void =>
    setIsSampleBasketAction(set, isSampleBasket),
}));

export default useSpecialPackagesStore;
